import { registerSessionCleanup } from 'src/auth/session-lifecycle';

import { useSettingStore } from '../stores/settingsStore';
import { useCustomerStore } from '../stores/customerStore';
import { useActivityStore } from '../stores/activityStore';
import { useTransactionStore } from '../stores/transactionStore';
import { usePaymentMethodStore } from '../stores/paymentMethodStore';

export function resetPointPayStores(): void {
  // Explicit empty data avoids restoring development fixtures on logout.
  useCustomerStore.setState({ ...useCustomerStore.getInitialState(), customers: [] }, true);
  useActivityStore.setState({ ...useActivityStore.getInitialState(), activities: [] }, true);
  useSettingStore.setState(useSettingStore.getInitialState(), true);
  useTransactionStore.setState(
    { ...useTransactionStore.getInitialState(), transactions: [] },
    true
  );
  usePaymentMethodStore.setState({ ...usePaymentMethodStore.getInitialState(), methods: [] }, true);
}

// Keep cleanup available even when a connectivity screen has unmounted the router.
registerSessionCleanup(resetPointPayStores);
